module.exports = new __parcel__URL__("icons.c14567a0.svg").toString();